import React, { ReactNode, useContext } from 'react'

import AdobeFonts, { FontType } from '@atoms/AdobeFonts'
import Footer from '@src/components/Footer'
import Header from '@src/components/Header'
import Banner from '@src/components/Banner'
import Menu from '@src/components/Menu'
import CookieConsent from '@src/components/CookieConsent'
import ContactModal from '@src/components/ContactModal'
import Toast from '@src/components/Toast'
import { useTranslation } from '@models/Translation'
import { StoreContext } from '@models/Store'

import '@src/assets/app.sass'
import * as style from './style.module.sass'

type LayoutProps = {
  noHeader?: boolean
  fontType?: FontType
  children: ReactNode
  handleQueryChangeForSearchPage?: (query: string) => void
}

const Layout: React.FC<LayoutProps> = ({
  noHeader = false,
  fontType = 'default',
  children,
  handleQueryChangeForSearchPage,
}) => {
  const { locale, path } = useTranslation()
  const { app, ui } = useContext(StoreContext)
  const color =
    ui.showMenu || ['/', '/about'].includes(path) ? 'subWhite' : 'white'

  return (
    <div
      className={style.layout}
      data-locale={locale}
      data-show={!app.loading || app.isFirstLoad}
    >
      <AdobeFonts fontType={fontType} />
      <Banner />
      <div
        className={style.contents}
        data-color={color}
        data-with-banner={ui.banner !== undefined}
      >
        {!noHeader && <Header />}
        {children}
        <Footer />
      </div>
      <Menu handleQueryChangeOnSearchPage={handleQueryChangeForSearchPage} />
      <ContactModal />
      <CookieConsent />
      <Toast />
    </div>
  )
}

export default Layout
